import { Box, Button, Stack, Typography } from "@mui/material";
import { CloseDrawerIcon } from "../components/ui-elements/svg-icons";
import ModalContainer from "./ui-elements/modal-container";
import { useNavigate } from "react-router-dom";
import { PATH_ONBOARD } from "../routes/path";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { useNotificationService } from "../hooks/notification";

const UnverifiedModalContent = ({
  open,
  handle_modal,
}: {
  open: boolean;
  handle_modal: () => void;
}) => {
  const navigate = useNavigate();
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const { showNotification } = useNotificationService();

  const handle_verify = () => {
    handle_modal();
    handleVerifyCheck();
  };

  const handleVerifyCheck = () => {
    if (!account_profile.name && account_profile.kyced === 0) {
      // user has not filled the onboarding form
      navigate(PATH_ONBOARD.root);
    } else if (account_profile.name && account_profile.kyced === 0) {
      // user has not completed the onboarding form

      navigate(PATH_ONBOARD.account);
    }
  };
  return (
    <ModalContainer
      size="sm"
      openModal={open}
      handleModal={handle_modal}
      sx={{}}
      fullWidth={false}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={handle_modal}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/caution-icon.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Complete account setup
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            To access this feature, upload your valid voter's card. Verification
            helps ensure a personalised experience for all users.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              borderRadius: 40,
              boxShadow: "none",
            }}
            onClick={handle_verify}
          >
            verify Account
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export default UnverifiedModalContent;
